import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

// compareSetTimes moved to @produce/shared — import from there
export { compareSetTimes } from "@produce/shared";
